import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { Title } from '../../HomePage/Articles/styled';
import RelatedArticlesCard from './RelatedArticlesCard';
import {
  ContentCardsContainer,
  OutterContainer,
  Pinkrightarrow,
  Sliderarrow,
} from './styled';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function RelatedArticle(props) {
  const { data, title } = props;
  const containerRef = useRef();
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const titleToShow = title ? title : 'TOPICS YOU MIGHT LIKE';
  const slide = (direction) => {
    const container = containerRef.current;

    let scrollCompleted = 0;
    const slideVar = setInterval(function () {
      if (direction == 'left') {
        container.scrollLeft -= 29;
      } else {
        container.scrollLeft += 29;
      }
      scrollCompleted += 10;
      if (scrollCompleted >= 100) {
        container?.scrollLeft ===
        container?.scrollWidth - container?.offsetWidth
          ? setShowRightArrow(false)
          : setShowRightArrow(true);
        container?.scrollLeft === 0
          ? setShowLeftArrow(false)
          : setShowLeftArrow(true);
        clearInterval(slideVar);
      }
    }, 10);
  };

  useEffect(() => {
    const contentIds = data?.map((item) => item?.term_id);
    fireServedSectionEvent(titleToShow, contentIds);
  }, []);

  return (
    <OutterContainer>
      <Title>{titleToShow}</Title>
      {showLeftArrow && (
        <Sliderarrow left onClick={() => slide('left')}>
          <Pinkrightarrow src={images.pinkrightarrow} alt="" />
        </Sliderarrow>
      )}
      <ContentCardsContainer ref={containerRef}>
        {data?.map((item, index) => (
          <RelatedArticlesCard
            key={index}
            itemData={item}
            title={titleToShow}
          />
        ))}
      </ContentCardsContainer>
      {showRightArrow && (
        <Sliderarrow right onClick={() => slide('right')}>
          <Pinkrightarrow left src={images.pinkrightarrow} alt="" />
        </Sliderarrow>
      )}
    </OutterContainer>
  );
}
